import {
	isDealerUser,
	isGlobalInventoryViewer,
	isGlobalManager,
	isLocalDealerViewer,
	isLocalMarketViewer,
	isLocalMediaManager,
	isMarketManager,
} from "@slfinrtl/ppn-roles"
import { useMemo } from "react"
import { getJwtPayload } from "src/common/jwt/jwtUtils"

type DealerAppNavigationType = "INVENTORY" | "MEDIA" | null

export const useDealerAppNavigationType = (): DealerAppNavigationType => {
	const jwtClaims = useMemo(() => getJwtPayload(), [])
	const ppnGroups = useMemo(() => jwtClaims?.["ppn:groups"], [jwtClaims])
	const hasMediaListPermissions = useMemo(() => !!ppnGroups && isLocalMediaManager(ppnGroups), [ppnGroups])
	const hasInventoryPermissions = useMemo(
		() =>
			!!ppnGroups &&
			!!jwtClaims &&
			(isGlobalManager(ppnGroups) ||
				isGlobalInventoryViewer(ppnGroups) ||
				isMarketManager(jwtClaims) ||
				isLocalMarketViewer(ppnGroups) ||
				isDealerUser(jwtClaims) ||
				isLocalDealerViewer(ppnGroups)),
		[ppnGroups, jwtClaims],
	)

	return hasInventoryPermissions ? "INVENTORY" : hasMediaListPermissions ? "MEDIA" : null
}
